import React, {Component, Fragment} from 'react';
// import { Helmet } from 'react-helmet';
import WithUser from '../WithUser';
// import { roles } from '../../helpers/auth';
import {selectors as portaleSelectors} from '../../reducers/currentPortaleV2';
// import WidgetUltimeModificheSito from 'components/widget/WidgetUltimeModificheSito';
// import WidgetSelectGestione from 'components/widget/WidgetSelectGestione';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
// import SelectPortaleV2 from '../SelectPortaleV2';
import WidgetGestionePortale from '../widget/WidgetGestionePortale';
import WidgetStatistichePortale from '../widget/WidgetStatistichePortale';

class DashboardPortali extends Component {
    render() {
        const {
            user,
            //userRole,
            //currentPortale,
        } = this.props;

        if (!user) {
            return <span>Perfavore effettua il login</span>;
        }

        // const isUser = userRole === roles.user;

        // const showPortaleFilter = !isUser;

        // const title = ;

        return (
            <Fragment>
                <div className="row py-2">
                    <div className="col-12">
                        <h2 className="text-primary text-center">
                            Benvenuto nella dashboard dei portali
                        </h2>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col-md-12">
                        <WidgetGestionePortale
                            // nomePortale={title}
                            // portaleId={currentPortale.value}
                        />
                    </div>
                    <div className="col-md-12">
                        <WidgetStatistichePortale
                            // portaleId={currentPortale.value}
                        />
                    </div>
                    {/*<div className="col-md-4">*/}
                    {/*    <WidgetUtilityPortale currentPortale={currentPortale} />*/}
                    {/*</div>*/}
                    {/*<div className="col-md-6">*/}
                    {/*    <WidgetUltimeModifichePortale />*/}
                    {/*</div>*/}
                    {/*<div className="col-md-6">*/}
                    {/*    <WidgetUltimeModifichePortale />*/}
                    {/*</div>*/}
                    {/* <div className="col-md-4">
                        <WidgetUltimeModificheSito />
                    </div> */}
                </div>
            </Fragment>
        );
    }
}

export default withRouter(
    connect((state) => ({
        currentPortale: portaleSelectors.getCurrentPortale(state),
    }))(WithUser(DashboardPortali))
);
